/*  Sample Api
    https://b2b.api.leisureq.io/ticket/v2/package/BB0DC3B6230
    https://b2b.api.leisureq.io/ticket/v2/barcode/BB0DC3B6230/shop
    https://b2b.api.leisureq.io/ticket/v2/barcode/BB0DC3B6230/benefit
    https://b2b.api.leisureq.io/ticket/v2/barcode/BB0DC3B6230/history
    https://b2b.api.leisureq.io/ticket/v2/barcode/BB0DC3B6230/info
    https://b2b.api.leisureq.io/ticket/v2/barcode/BB0DC3B6230/info/2022
    https://b2b.api.leisureq.io/ticket/v2/barcode/BB0DC3B6230
    https://b2b.api.leisureq.io/api/v1/local/coupon/use?couponSeq=&{couponSeq}exOrderId={exOrderId}&qty={qty}
    https://b2b.api.leisureq.io/ticket/v2/barcode/BB0DC3B6230/2022
*/

import Api from './Api';

export default class {
    constructor(host = 'http://localhost:3000') {
        this.host = host;
        this.api = new Api(host);
    }

    // Tickets
    getTicketGroups = (barcode, shopCode) => {
        return this.api.get(`/ticket/v2/barcode/${barcode}/${shopCode}`);
    }
    getTicketInfo = (barcode, shopCode) => {
        return this.api.get(`/ticket/v2/barcode/${barcode}/info/${shopCode}`);
    }
    usingTicketBarcode = (pin) => {
        return this.api.post(`/coupon/use/${pin}`);
    }

    // Packages
    getShopGroups = (barcode) => {
        return this.api.get(`/ticket/v2/barcode/${barcode}/shop`);
    }
    getPackageInfo = (barcode) => {
        return this.api.get(`/ticket/v2/package/${barcode}`);
    }
    getBenefitGroups = (barcode) => {
        return this.api.get(`/ticket/v2/barcode/${barcode}/benefit`);
    }
    usingCoupon = (shopSeq, couponCode, count) => {
        return this.api.post(`/api/v1/local/coupon/use?couponSeq=${shopSeq}&exOrderId=${couponCode}&qty=${count}`);
    }
    getHistoryGroups = (barcode) => {
        return this.api.get(`/ticket/v2/barcode/${barcode}/history`);
    }

    getReservationDate = (pin) => {
        return this.api.get(`/api/reservation/${pin}/info`);
    }

    getOptionGroupData = (pin, roSeq, date) => {
        return this.api.get(`/api/reservation/${pin}/child?roSeq=${roSeq}&date=${date}`);
    }

    callReservation = (pin, data) => {
        return this.api.post(`/api/reservation/${pin}/create`, data);
    }

    getReservationInfo(pin) {
        return this.api.get(`/api/reservation/${pin}/completed`);
    }
}


// WEBPACK FOOTER //
// ./src/api/ApiMethod.js